package de.oevbs.kunde.kundenportal2.services.tax

import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.authentication.PortalSessionMiddleware
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalInitTracker
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.kunde.kundenportal2.model.services.tax.*
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import de.oevbs.sfa.communication.use
import de.oevbs.sfa.data.time.now
import dev.fritz2.core.SimpleHandler
import dev.fritz2.core.Store
import dev.fritz2.core.invoke
import dev.fritz2.core.storeOf
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow
import kotlinx.datetime.LocalDate

class TaxStore(job: Job) : ValidatingStore<Tax, Unit, ComponentValidationMessage>(
    Tax(LocalDate.now().year - 1),
    Tax.validation,
    Unit,
    job,
    validateAfterUpdate = false
) {
    private val client = TaxClient().use(PortalSessionMiddleware)

    private val progressStore = storeOf(GeneralProgressStep.SUBMIT1, job)
    val currentStep: Flow<GeneralProgressStep> = progressStore.data

    private val initFailedStore = storeOf(false, Job())
    val initFailedFlow: Flow<Boolean> = initFailedStore.data

    val selectedYear = LocalDate.now().year - 1 //map(Tax.selectedYear()) //Fixme: Jahre wieder einbauen
    val selectedContracts = map(Tax.selectedContracts())

    val yearsToContractsStore: Store<Map<Int, YearContracts>> = storeOf(emptyMap(), job)

    val taxResultStore: Store<TaxResult> = storeOf(TaxResult(), job)

    val requestTax: SimpleHandler<Unit> = handle { currentModel ->

        GlobalServiceMessagesStore.clear()

        if (!validate(currentModel).valid) {
            return@handle currentModel
        }

        val results = globalSubmitTracker.track {
            requestTax(currentModel)
        }

        if (results != null) {
            taxResultStore.update(results)
            progressStore.update(GeneralProgressStep.SUCCESS2)
        }

        // Das Model wird noch zum Erstellen einer MessagePage benötigt
        currentModel

    }

    val init: SimpleHandler<Unit> = yearsToContractsStore.handle { currentMap ->
        GlobalServiceMessagesStore.clear()

        globalInitTracker.track {
            val initData = initTax()?.yearsToContracts
            if (initData == null) {
                initFailedStore.update(true)
                return@track currentMap
            }
            initData
        }
    }

    private suspend fun requestTax(tax: Tax): TaxResult? {
        return tryCatchAndHandleErrors("Anfordern von Kfz-Steuerbescheinigungen") {
            client.create(tax)
        }
    }

    private suspend fun initTax(): TaxInit? {
        return tryCatchAndHandleErrors("Initialisieren der Kfz-Steuerbescheinigungen") {
            client.init()
        }
    }

    private fun testData() = mapOf(
        Pair(
            selectedYear, YearContracts(
                listOf(
                    CarContract("243899000", "PKW", "BS AU 345"),
                    CarContract("22222890003", "Anhänger", "OHA DA 1234"),
                    CarContract("11345235", "Lastkraftwagen", "B EN 1"),
                    CarContract("55555389", "Personenkraftwagen", "BS AU 345"),
                    CarContract("7892289", "Mofa", "BRZ 879"),
                    CarContract("156345235", "LKW", "B EN 1"),
                    CarContract("1243899000", "PKW", "BS AU 345"),
                    CarContract("99222890003", "Anhänger", "OHA DA 1234"),
                    CarContract("21345235", "Lastkraftwagen", "B EN 1"),
                    CarContract("895555389", "Personenkraftwagen", "BS AU 345"),
                    CarContract("17892289", "Mofa", "BRZ 879"),
                    CarContract("5156345235", "LKW", "B EN 1")
                ), invalidContractsCount = 5
            )
        )
    )
}